import React, { useState } from "react";
import axios from "axios";

export default function SendTestModal({
  show,
  onClose,
  templateId,
  variables,
  tenantEmail,
}) {
  const [testPhone, setTestPhone] = useState("");
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");

  if (!show) return null;

  const handleSend = async () => {
    if (!testPhone.trim()) {
      setMsg("Please enter a phone number.");
      return;
    }

    setLoading(true);
    setMsg("");

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/whatsapp/send-test`,
        {
          email: tenantEmail,
          testPhone,
          templateId,
          variables,
        },
        {
          headers: {
            "x-email": tenantEmail,
          },
        }
      );

      setMsg("Test message sent successfully!");
    } catch (err) {
      setMsg("Failed to send test message.");
    }

    setLoading(false);
  };

  return (
    <div className="modal fade show" style={{ display: "block" }}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Send Test Message</h5>
            <button className="btn-close" onClick={onClose}></button>
          </div>

          <div className="modal-body">
            <label className="form-label fw-semibold">Mobile Number</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter mobile number"
              value={testPhone}
              onChange={(e) => setTestPhone(e.target.value)}
            />

            {msg && <p className="mt-3 text-primary">{msg}</p>}
          </div>

          <div className="modal-footer">
            <button className="btn btn-secondary" onClick={onClose}>
              Close
            </button>
            <button
              className="btn btn-primary"
              onClick={handleSend}
              disabled={loading}
            >
              {loading ? "Sending..." : "Send Test"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
